import { render, staticRenderFns } from "./GalleryLists.vue?vue&type=template&id=a212d890"
import script from "./GalleryLists.vue?vue&type=script&lang=js"
export * from "./GalleryLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports